import {Component, OnDestroy, OnInit} from '@angular/core';
import {Partner} from '../../model/partner';
import {ObjectList} from '../../model/object-list';
import {PartnersResource} from '../../model/model-resource';

@Component({
  selector: 'app-partners-list-page',
  templateUrl: './partners-list-page.component.html',
  styleUrls: ['./partners-list-page.component.scss']
})
export class PartnersListPageComponent implements OnInit, OnDestroy {

  partners: ObjectList<Partner>;
  columns = ['name', 'created', 'actions'];

  constructor(private resource: PartnersResource) {
  }

  ngOnInit() {
    this.partners = new ObjectList<Partner>('partners', this.resource);
    this.partners.setFilter('parentPartnerId', 'null', '=');
  }

  ngOnDestroy() {
    this.partners.disconnect();
    this.partners = null;
  }

}
